import { createSelector } from '@reduxjs/toolkit';

import { StoreState } from '../types';

import { SidesheetState } from './types';

export const getSidesheet = (state: StoreState): SidesheetState =>
  state.sidesheet;

export const getSidesheetMode = createSelector(getSidesheet, state =>
  state.current ? state.slots[state.current].mode ?? null : null,
);
